import { rgba } from 'polished';
var PALETTE = {
  black: '#000',
  white: '#fff',
  blue50: '#F5F9FF',
  blue100: '#C2DBFD',
  blue200: '#93BDF8',
  blue300: '#66A0F0',
  blue400: '#3D83E5',
  blue500: '#2369CB',
  blue600: '#205297',
  blue700: '#1C3D6B',
  blue800: '#13253E',
  blue900: '#070D14',
  grey100: '#2A2A2A',
  grey150: '#0D2A38',
  grey180: '#2F3640',
  grey200: '#353B48',
  grey250: '#606775',
  grey400: '#687687',
  grey700: '#A7A7A7',
  grey800: '#DCDDE1',
  grey900: '#F5F6FA',
  red400: '#DA291C',
  red450: '#C23616',
  red500: '#E84118',
  red900: '#F8C6B9',
  green200: '#BFD22B',
  green300: '#139700',
  green500: '#4CD137',
  green900: '#C9F1C1',
  yellow400: '#F4A523',
  yellow450: '#E1B12C',
  yellow500: '#FBC531',
  yellow900: '#F4DDB9',
  purple200: '#BBAEFE',
  purple900: '#E4DFFF'
};
export var color = {
  // Colors (semantic, depends on raw brand colors).
  link: PALETTE.blue500,
  linkSecondary: PALETTE.blue200,
  action: PALETTE.blue500,
  actionHover: PALETTE.blue600,
  loginAction: PALETTE.blue700,
  loginActionHover: PALETTE.blue800,
  menuItemActive: PALETTE.blue200,
  menuItemSecondaryActive: PALETTE.blue700,
  alert: PALETTE.red500,
  alertHover: PALETTE.red450,
  textBold: PALETTE.grey180,
  textPrimary: PALETTE.grey200,
  textSecondary: PALETTE.grey400,
  textInput: PALETTE.grey200,
  placeholder: PALETTE.grey400,
  label: PALETTE.grey400,
  invalid: PALETTE.red450,
  imgBackground: PALETTE.grey800,
  disabled: PALETTE.grey400,
  disabledSwitch: PALETTE.grey700,
  border: PALETTE.grey800,
  borderOnDark: rgba(PALETTE.white, 0.1),
  borderInput: PALETTE.grey400,
  background: PALETTE.white,
  backgroundSecondary: PALETTE.grey900,
  backgroundDark: PALETTE.grey200,
  success: PALETTE.green500,
  avatarBackground: PALETTE.grey400,
  header: PALETTE.grey400,
  icon: PALETTE.grey400,
  iconHover: PALETTE.grey200,
  scpGreen: PALETTE.green200,
  ripple: rgba(PALETTE.black, 0.3),
  rippleOnDark: rgba(PALETTE.white, 0.7),
  rippleOnDarkNative: rgba(PALETTE.white, 0.1),
  rippleAndroid: rgba(PALETTE.black, 0.2),
  rippleIOS: PALETTE.grey900,
  indicator: PALETTE.red500,
  highlight: PALETTE.yellow450,
  active: PALETTE.blue50,
  activeSecondary: PALETTE.yellow500,
  warning: PALETTE.yellow400,
  overlay: rgba(PALETTE.black, 0.4),
  menuInactive: PALETTE.grey200,
  menuInactiveOnDark: PALETTE.grey800,
  info: PALETTE.blue500,
  brandCare: PALETTE.grey200,
  brandConnect: PALETTE.grey100,
  brandPractice: PALETTE.blue800,
  brandPortal: PALETTE.grey150,
  brandAdmin: PALETTE.black,
  brandPatient: PALETTE.white,
  // Color palette should only be used when there's no appropriate "semantic" color.
  palette: PALETTE
};